export const AIRLINE_CODES: { [key: string]: string } = {
     'AA': 'American Airlines',
     'AS': 'Alaska Airlines',
     'B6': 'JetBlue Airways',
     'DL': 'Delta Air Lines',
     'F9': 'Frontier Airlines',
     'G4': 'Allegiant Air',
     'HA': 'Hawaiian Airlines',
     'NK': 'Spirit Airlines',
     'SY': 'Sun Country Airlines',
     'UA': 'United Airlines',
     'VX': 'Virgin America',
     'WN': 'Southwest Airlines',
     'YX': 'Republic Airways',
     'YV': 'Mesa Airlines',
     'ZW': 'Air Wisconsin',
     '9E': 'Endeavor Air',
     'CP': 'Compass Airlines',
     'EV': 'ExpressJet Airlines',
     'G7': 'GoJet Airlines',
     'MQ': 'Envoy Air',
     'OH': 'PSA Airlines',
     'OO': 'SkyWest Airlines',
     'PT': 'Piedmont Airlines',
     'QX': 'Horizon Air',
     'SUR': 'Surface/Misc Duty'
}
